export default function CTASection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="mx-auto" style={{ maxWidth: 1200 }}>
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20collage%20of%20fashion%20items%20including%20sneakers%20hoodies%20t-shirts%20and%20bags%20with%20soft%20film%20grain%20texture%2C%20cream%20and%20beige%20tones%2C%20dreamy%20edit%2C%20editorial%20fashion%20photography%2C%20minimalist%20scandinavian%20style&width=1400&height=600&seq=cta-section-01&orientation=landscape"
            alt="GTBuy fashion collage"
            className="w-full h-[350px] md:h-[420px] object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-foreground-950/20 to-transparent"></div>

          <div className="absolute inset-0 flex flex-col items-center justify-end pb-12 md:pb-16 px-4 text-center">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3">
              Find Your Style
              <br />
              <span className="text-background-50/70 font-normal italic">Compare on GTBuy Sheet · Shop Smarter in 2026</span>
            </h2>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="mt-6 inline-flex items-center gap-2 px-10 py-3.5 bg-background-50 text-foreground-950 font-semibold text-sm rounded-full hover:bg-background-100 hover:scale-105 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-shopping-cart-line text-lg"></i>
              Buy It Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}